import React, { useState } from 'react';
import './NavLinks.scss';
import { useSelector } from 'react-redux';
import NavLinkDropdown from '../NavLinkDropdown/NavLinkDropdown';
import { triggerDataLayerOnCtaClick } from '../../../../own-days/helper';

const NavLinks = () => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const navigation = useSelector(state => state?.header?.mainNavigationData?.navigation);

  const handleMouseEnter = index => {
    setHoveredItem(index);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  if (navigation && Array.isArray(navigation) && navigation.length > 0) {
    return (
      <nav className="odNav">
        <ul className="odNav__list">
          {navigation.map((nav, index) => (
            <li
              key={nav.title}
              className={`odNav__listItem ${
                nav?.title === 'ACCESSORIES' ? 'odNav__listItemAccessories' : ''
              }`}
              onMouseEnter={() => handleMouseEnter(index)}
            >
              <a
                className="odNav__link odNav__listItemLink"
                href={nav.link}
                onClick={() => triggerDataLayerOnCtaClick(nav.title)}
              >
                {nav.title}
              </a>
              <NavLinkDropdown
                handleMouseLeave={handleMouseLeave}
                hoveredItem={hoveredItem}
                index={index}
                nav={nav}
              />
            </li>
          ))}
        </ul>
      </nav>
    );
  }

  return null;
};

export default NavLinks;
